import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import LoginForm from './components/LoginForm';
import SocialLogin from './components/SocialLogin';
import LoginBenefits from './components/LoginBenefits';
import Icon from '../../components/AppIcon';
import { useAuth } from '../../contexts/AuthContext';


const Login = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    // Check if user is already authenticated
    if (user && !loading) {
      navigate('/user-profile', { replace: true });
    }
  }, [user, loading, navigate]);

  const handleSocialLogin = (provider) => {
    // TODO: Implement real OAuth integration with providers like Google, Facebook, etc.
    console.log(`Social login with ${provider} - not yet implemented`);
    // For now, redirect to registration page
    navigate('/register');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="pt-16">
        <div className="min-h-screen flex">
          {/* Left Side - Login Form */}
          <div className="flex-1 flex items-center justify-center p-6 lg:p-12">
            <div className="w-full max-w-md space-y-8">
              <LoginForm />

              <div className="mt-8">
                <SocialLogin
                  isLoading={false}
                  onSocialLogin={handleSocialLogin}
                />
              </div>
            </div>
          </div>

          {/* Right Side - Benefits (Desktop Only) */}
          <LoginBenefits />
        </div>
      </main>

      {/* Mobile Benefits Section */}
      <div className="lg:hidden bg-primary/5 p-6">
        <div className="max-w-md mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-3">
              Why Join Us?
            </h2>
            <p className="text-muted-foreground">
              Discover the benefits of being part of our wellness community
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                <Icon name="Heart" size={24} color="var(--color-primary)" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">Save Favourites</h3>
              <p className="text-sm text-muted-foreground">
                Keep track of your preferred practitioners
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                <Icon name="Calendar" size={24} color="var(--color-primary)" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">Easy Booking</h3>
              <p className="text-sm text-muted-foreground">
                Book sessions with integrated booking
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
